import React from 'react';
import { motion } from 'framer-motion';
import { twMerge } from 'tailwind-merge';
import { spring } from '../../utils/motion';
interface EmptyStateProps {
  icon: React.ReactNode;
  title: string;
  body: string;
  children?: React.ReactNode;
  className?: string;
}
export function EmptyState({
  icon,
  title,
  body,
  children,
  className
}: EmptyStateProps) {
  return <div className={twMerge('flex flex-col items-center px-6 py-12 text-center', className)} data-id="element-781" data-mp="vob4huqlzdmz">
      <motion.div initial={{
      scale: 0.96,
      opacity: 0
    }} animate={{
      scale: 1,
      opacity: 1
    }} transition={spring.bouncy} className="mb-5 grid h-16 w-16 place-items-center rounded-md bg-tint text-brand-strong" data-id="element-782" data-mp="vmhvw9wfqjcc">
        {icon}
      </motion.div>
      <h3 className="text-xl font-bold tracking-[-0.01em]" data-id="element-783" data-mp="19h0u095cj0ou">{title}</h3>
      <p className="mt-2 max-w-[36ch] text-[15px] leading-relaxed text-ink-2" data-id="element-784" data-mp="cx1tti53qitt">{body}</p>
      {children && <div className="mt-6 flex flex-wrap justify-center gap-3" data-id="element-785" data-mp="gy3um3eo32xw">{children}</div>}
    </div>;
}